import { RootState } from '../store';

export const selectOverview = (state: RootState) => state.overview.overview;

export const selectOverviewRequestStatus = (state: RootState) => state.overview.overviewRequestStatus;
